"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadOrderbook = exports.createTokenAccount = exports.createMint = exports.printOrders = exports.mintToAccount = exports.getVaultOwnerAndNonce = exports.DEX_PID = void 0;
// TODO: Modernize all these apis. This is all quite clunky.
const axios_1 = __importDefault(require("axios"));
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const serum_1 = require("@project-serum/serum");
exports.DEX_PID = new web3_js_1.PublicKey("FSrM9nHBx8xnHBHfrmyj5eB5R2uAK2CoYE4tcT25R2am");
function getVaultOwnerAndNonce(marketPublicKey, dexProgramId = exports.DEX_PID) {
    const nonce = new anchor_1.BN(0);
    while (nonce.toNumber() < 255) {
        try {
            const vaultOwner = anchor_1.utils.publicKey.createProgramAddressSync([marketPublicKey.toBuffer(), nonce.toArrayLike(Buffer, "le", 8)], dexProgramId);
            return [vaultOwner, nonce.toNumber()];
        }
        catch (e) {
            nonce.iaddn(1);
        }
    }
    throw new Error("Unable to find nonce");
}
exports.getVaultOwnerAndNonce = getVaultOwnerAndNonce;
async function mintToAccount(provider, mint, destination, amount, mintAuthority) {
    const tx = new web3_js_1.Transaction().add(...(await createMintToAccountInstrs(mint, destination, amount, mintAuthority)));
    await provider.send(tx);
}
exports.mintToAccount = mintToAccount;
async function createMintToAccountInstrs(mint, destination, amount, mintAuthority) {
    return [
        serum_1.TokenInstructions.mintTo({
            mint,
            destination: destination,
            amount: amount,
            mintAuthority: mintAuthority,
        }),
    ];
}
// async function setAuthority(provider, mint, newAuthority, mintAuthority) {
//   // mint authority is the provider
//   const tx = new Transaction();
//   tx.add(
//     ...(await createSetAuthorityInstrs(mint, mintAuthority, newAuthority)),
//   );
//   await provider.send(tx, []);
//   return;
// }
// async function createSetAuthorityInstrs(
//   target,
//   currentAuthority,
//   newAuthority,
// ) {
//   // This is the enum value for authority type
//   // https://github.com/solana-labs/solana-program-library/blob/master/token/program/src/instruction.rs#L583-L613
//   const authorityType = new anchor.BN(0);
//   return [
//     TokenInstructions.setAuthority({
//       target,
//       currentAuthority,
//       newAuthority,
//       authorityType,
//     }),
//   ];
// }
async function printOrders(marketClient, provider) {
    // Check the orders
    // Fetching orderbooks
    console.log("calling printOrders:");
    let bids = await marketClient.loadBids(provider.connection);
    let asks = await marketClient.loadAsks(provider.connection);
    // Full orderbook data
    for (let order of asks) {
        console.log(order.orderId.toString(), order.price.toString(), 
        // order.priceLots.toNumber(),
        order.size, 
        // order.sizeLots.toNumber(),
        order.side);
    }
    // Full orderbook data
    // TODO how to print in reverse?
    for (let order of bids) {
        console.log(order.orderId.toString(), 
        // order.orderId,
        order.price.toString(), 
        // order.priceLots.toNumber(),
        order.size, 
        // order.sizeLots.toNumber(),
        order.side);
    }
}
exports.printOrders = printOrders;
async function createMint(provider, authority, decimals, mint) {
    if (authority === undefined) {
        authority = provider.wallet.publicKey;
    }
    if (decimals === undefined) {
        decimals = 6;
    }
    const mintToUse = mint || new web3_js_1.Keypair();
    const instructions = await createMintInstructions(provider, authority, mintToUse.publicKey, decimals);
    const tx = new web3_js_1.Transaction();
    tx.add(...instructions);
    await provider.send(tx, [mintToUse]);
    return mintToUse.publicKey;
}
exports.createMint = createMint;
async function createMintInstructions(provider, authority, mint, decimals) {
    let instructions = [
        web3_js_1.SystemProgram.createAccount({
            fromPubkey: provider.wallet.publicKey,
            newAccountPubkey: mint,
            space: 82,
            lamports: await provider.connection.getMinimumBalanceForRentExemption(82),
            programId: serum_1.TokenInstructions.TOKEN_PROGRAM_ID,
        }),
        serum_1.TokenInstructions.initializeMint({
            mint,
            decimals: decimals,
            mintAuthority: authority,
        }),
    ];
    return instructions;
}
async function createTokenAccount(provider, mint, owner) {
    const vault = new web3_js_1.Keypair();
    const tx = new web3_js_1.Transaction();
    tx.add(...(await createTokenAccountInstrs(provider, vault.publicKey, mint, owner)));
    await provider.send(tx, [vault]);
    return vault.publicKey;
}
exports.createTokenAccount = createTokenAccount;
async function createTokenAccountInstrs(provider, newAccountPubkey, mint, owner, lamports) {
    if (lamports === undefined) {
        lamports = await provider.connection.getMinimumBalanceForRentExemption(165);
    }
    return [
        web3_js_1.SystemProgram.createAccount({
            fromPubkey: provider.wallet.publicKey,
            newAccountPubkey,
            space: 165,
            lamports,
            programId: serum_1.TokenInstructions.TOKEN_PROGRAM_ID,
        }),
        serum_1.TokenInstructions.initializeAccount({
            account: newAccountPubkey,
            mint,
            owner,
        }),
    ];
}
async function loadOrderbook(bidAccounts, askAccounts, marketDetail, endpoint, commitment) {
    const bids = [];
    const asks = [];
    const commitmentToUse = commitment || "confirmed";
    const accountsData = await axios_1.default.post(endpoint, {
        jsonrpc: "2.0",
        id: "1",
        method: "getMultipleAccounts",
        params: [
            [...bidAccounts, ...askAccounts],
            {
                commitment: commitmentToUse,
            },
        ],
    });
    accountsData.data.result.value.forEach((item, index) => {
        if (item?.data) {
            const { data = null } = item;
            if (index < marketDetail.length) {
                const myBuffer = Buffer.from(data[0], data[1]);
                const decoded = serum_1.Orderbook.decode(marketDetail[index], myBuffer);
                bids.push(decoded);
            }
            else {
                const myBuffer = Buffer.from(data[0], data[1]);
                const decoded = serum_1.Orderbook.decode(marketDetail[index - marketDetail.length], myBuffer);
                asks.push(decoded);
            }
        }
        else {
            // keep order when some markets are resolved
            bids.push(null);
            asks.push(null);
        }
    });
    return {
        bids,
        asks,
    };
}
exports.loadOrderbook = loadOrderbook;
//# sourceMappingURL=misc.js.map